import type { DropAnimation } from "@dnd-kit/core";
import { DragOverlay, defaultDropAnimationSideEffects } from "@dnd-kit/core";
import { createPortal } from "react-dom";

const dropAnimationConfig: DropAnimation = {
  sideEffects: defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: "0.4",
      },
    },
  }),
};

export function SortableOverlay() {
  return createPortal(
    <DragOverlay dropAnimation={dropAnimationConfig} className="opacity-10" />,
    document.body,
  );
}
